import {
  getObjectFromLocalStorage,
  removeFromLocalStorage,
  setObjectInLocalStorage,
} from "@/common/helpers/localStorage";

const PENDING_REFERRAL_LIFETIME_MS = 30 * 24 * 60 * 60 * 1000;

type PendingReferral = {
  referredByOrganizationId: string;
  savedAtMs: number;
};

export class PendingReferralStore {
  static store(referredByOrganizationId: string) {
    setObjectInLocalStorage?.("pendingReferral", { referredByOrganizationId, savedAtMs: Date.now() });
  }

  static get(): string | undefined {
    const pendingReferral = getObjectFromLocalStorage<PendingReferral>?.("pendingReferral");
    if (!pendingReferral || Date.now() - pendingReferral.savedAtMs > PENDING_REFERRAL_LIFETIME_MS) {
      return undefined;
    }
    return pendingReferral.referredByOrganizationId;
  }

  static clear() {
    removeFromLocalStorage?.("pendingReferral");
  }
}
